import script from "./NigeriaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NigeriaPage.vue?vue&type=script&setup=true&lang=js"

import "./NigeriaPage.vue?vue&type=style&index=0&id=564291cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564291cf"]])

export default __exports__